import React from 'react';
import ButtonGroup from 'ub/components/properties-panel/button-group';

const FontStyleButtonGroup = ({textStyles, changeHandler, allowedStyles}) => {
  const _triggerChangeForStyle = (style) => {
    changeHandler({
      type: 'styleChange',
      value: style
    });
  };

  const allStyles = {
    bold: {
      iconClass: "svg-ico-bold",
      clickHandler: () => _triggerChangeForStyle('strong'),
      isActive: textStyles && textStyles.strong,
      title: 'Bold'
    },
    italic: {
      iconClass: "svg-ico-italic",
      clickHandler: () => _triggerChangeForStyle('em'),
      isActive: textStyles && textStyles.em,
      title: 'Italic'
    },
    underline: {
      iconClass: "svg-ico-underline",
      clickHandler: () => _triggerChangeForStyle('u'),
      isActive: textStyles && textStyles.u,
      title: 'Underline'
    },
    strikethrough: {
      iconClass: "svg-ico-strikethrough",
      clickHandler: () => _triggerChangeForStyle('s'),
      isActive: textStyles && textStyles.s,
      title: 'Strikethrough'
    },
    superscript: {
      iconClass: "svg-ico-superscript",
      clickHandler: () => _triggerChangeForStyle('sup'),
      isActive: textStyles && textStyles.sup,
      title: 'Superscript'
    },
    subscript: {
      iconClass: "svg-ico-subscript",
      clickHandler: () => _triggerChangeForStyle('sub'),
      isActive: textStyles && textStyles.sub,
      title: 'Subscript'
    }
  };

  const styleOptions = allowedStyles.map((style) => {
    return allStyles[style];
  });

  return (<ButtonGroup options={styleOptions} />);
};

FontStyleButtonGroup.propTypes = {
  allowedStyles: React.PropTypes.arrayOf(React.PropTypes.string).isRequired,
  textStyles: React.PropTypes.object.isRequired,
  changeHandler: React.PropTypes.func.isRequired,
};

export default FontStyleButtonGroup;



// WEBPACK FOOTER //
// ./src/components/properties-panel/font-style-button-group.jsx